import api from '@anm/api';
import { HostingUser } from '@anm/api/modules/hosting';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userActions, userSelectors } from '../../../../store/modules/user';

const useHostingUserStatus = () => {
  const dispatch = useDispatch();
  const userHostingStatus = useSelector(userSelectors.selectUserBlockedOnHosting);

  useEffect(() => {
    if (typeof userHostingStatus === 'boolean') return;

    (async () => {
      const user: HostingUser = await api().hosting.getHostingUser();
      const isBlocked = user.status === 'blocked';

      dispatch(userActions.setIsUserBlockedOnHosting(isBlocked));
    })();
  }, [userHostingStatus]);

  return userHostingStatus;
};

export default useHostingUserStatus;
